import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  fetchChatSearchAsync,
  clearError,
  clearMessage,
  clearChatData,
  setChatParams,
  setShowDropdown
} from '../features/chat/chat.slice';
import type { RootState, AppDispatch } from '../store';
import type { ChatSearchParams } from '../api/chat';


export const useChatSearch = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    chatData,
    loading,
    error,
    message,
    currentParams,
    showDropdown
  } = useSelector((state: RootState) => state.chat);

  // Fetch chat search data
  const fetchChatSearch = useCallback((params?: ChatSearchParams) => {
    if (params) {
      dispatch(setChatParams(params));
      return dispatch(fetchChatSearchAsync(params));
    } else {
      return dispatch(fetchChatSearchAsync(currentParams));
    }
  }, [dispatch, currentParams]);

  // Set dropdown visibility
  const setDropdown = useCallback((visible: boolean) => {
    dispatch(setShowDropdown(visible));
  }, [dispatch]);

  // Clear error
  const handleClearError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  // Clear message
  const handleClearMessage = useCallback(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  // Clear all chat data
  const handleClearChatData = useCallback(() => {
    dispatch(clearChatData());
  }, [dispatch]);

  // Refresh data with current params
  const refreshChatSearch = useCallback(() => {
    return dispatch(fetchChatSearchAsync(currentParams));
  }, [dispatch, currentParams]);

  return {
    chatData,
    loading,
    error,
    message,
    currentParams,
    showDropdown,
    fetchChatSearch,
    setDropdown,
    handleClearError,
    handleClearMessage,
    handleClearChatData,
    refreshChatSearch,
  };
};
